/**
 * 근태 수정 모달의 시간 재계산·합계 검증 — app.ts에서 추출한 순수 함수.
 * 소정 4구분(일반/야간/휴일일반/휴일야간)만 계산하고 초과 4종은 건드리지 않는다.
 */

/** 8개 구분 시간의 합(휴게 제외, 소수점 1자리). */
export function editHoursSum(h: Record<string, number>): number {
  const sum =
    (h.regular || 0) +
    (h.overtime || 0) +
    (h.night || 0) +
    (h.nightOvertime || 0) +
    (h.holidayRegular || 0) +
    (h.holidayOvertime || 0) +
    (h.holidayNight || 0) +
    (h.holidayNightOvertime || 0);
  return Math.round(sum * 10) / 10;
}

/** 출퇴근 시간으로부터 기대 근무시간(휴게 제외). 미입력이면 null. 동시각은 24h(익일 규칙). */
export function expectedHoursFromTimes(
  checkIn: string,
  checkOut: string,
  breakHours: number,
): number | null {
  if (!(checkIn && checkOut)) {
    return null;
  }
  const [sh, sm] = checkIn.split(":").map(Number);
  const [eh, em] = checkOut.split(":").map(Number);
  let mins = eh * 60 + em - (sh * 60 + sm);
  if (mins <= 0) {
    mins += 24 * 60; // 익일 퇴근
  }
  const net = mins / 60 - (breakHours || 0);
  return Math.round(Math.max(0, net) * 10) / 10;
}

/** 소정 4구분 자동 계산 — 야간 22~06, 휴게는 주간 우선 차감. 미입력이면 null. */
export function scheduledSplitFromTimes(
  checkIn: string,
  checkOut: string,
  breakHours: number,
  isHoliday: boolean,
): { regular: number; night: number; holidayRegular: number; holidayNight: number } | null {
  if (!(checkIn && checkOut)) {
    return null;
  }
  const [sh, sm] = checkIn.split(":").map(Number);
  const [eh, em] = checkOut.split(":").map(Number);
  const start = sh * 60 + sm;
  let end = eh * 60 + em;
  if (end <= start) {
    end += 24 * 60; // 익일 퇴근
  }
  // 야간(22:00~익일06:00) 분 단위 합산
  let nightMin = 0;
  for (let m = start; m < end; m++) {
    const hod = Math.floor(m / 60) % 24;
    if (hod >= 22 || hod < 6) {
      nightMin++;
    }
  }
  const totalMin = end - start;
  const dayMin = totalMin - nightMin;
  // 휴게는 주간 우선 차감
  let breakMin = (breakHours || 0) * 60;
  const dayNet = Math.max(0, dayMin - breakMin);
  breakMin = Math.max(0, breakMin - dayMin);
  const nightNet = Math.max(0, nightMin - breakMin);
  const r1 = (n: number) => Math.round((n / 60) * 10) / 10;
  if (isHoliday) {
    return { regular: 0, night: 0, holidayRegular: r1(dayNet), holidayNight: r1(nightNet) };
  }
  return { regular: r1(dayNet), night: r1(nightNet), holidayRegular: 0, holidayNight: 0 };
}
